import { createElementBlock as l, openBlock as o, createElementVNode as n } from "vue";
const r = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return o(), l("svg", r, e[0] || (e[0] = [
    n("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.403 4.111a8.015 8.015 0 0 0-5.936 14.5 1 1 0 0 1-1.132 1.649 10.015 10.015 0 0 1 7.417-18.118 1 1 0 1 1-.35 1.97m4.905-2.123a1 1 0 0 1 1 1v1.253h1.253a1 1 0 1 1 0 2h-1.253v1.253a1 1 0 1 1-2 0V6.241h-1.253a1 1 0 1 1 0-2h1.253V2.988a1 1 0 0 1 1-1m1.985 6.37a1 1 0 0 1 1.253.657 10.015 10.015 0 0 1-11.491 12.809 1 1 0 1 1 .385-1.962A8.014 8.014 0 0 0 19.636 9.61a1 1 0 0 1 .657-1.253m-7.108-.413a1 1 0 1 0-2 0v4.425l-2.278.962a1 1 0 1 0 .777 1.842l2.89-1.219a1 1 0 0 0 .61-.921z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_duration_plus-B1j76Ipb.js.map
